var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69922 3H6.94922V1C6.94922 0.447917 6.5013 0 5.94922 0H1.19922C0.647135 0 0.199219 0.447917 0.199219 1V8C0.199219 8.55208 0.647135 9 1.19922 9H3.94922V11C3.94922 11.5521 4.39714 12 4.94922 12H9.69922C10.2513 12 10.6992 11.5521 10.6992 11V4C10.6992 3.44792 10.2513 3 9.69922 3ZM1.86589 7V2C1.86589 1.81583 2.01505 1.66667 2.19922 1.66667H4.94922C5.13339 1.66667 5.28255 1.81583 5.28255 2V7C5.28255 7.18417 5.13339 7.33333 4.94922 7.33333H2.19922C2.01505 7.33333 1.86589 7.18417 1.86589 7ZM8.69922 10.3333H5.94922C5.76505 10.3333 5.61589 10.1842 5.61589 10V9H5.94922C6.5013 9 6.94922 8.55208 6.94922 8V4.66667H8.69922C8.88339 4.66667 9.03255 4.81583 9.03255 5V10C9.03255 10.1842 8.88339 10.3333 8.69922 10.3333Z",
    fill: "#89A0BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.7f5cc8f885c76ac7df3553b7d05b8b3c.svg";
export { ForwardRef as ReactComponent };